(function () {
  'use strict';
  var cfg = window.KD || {};
  var currency = cfg.currency || 'EUR';
  var locale = cfg.locale || undefined;
  function money(cents) {
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#kd-cart');
  var upsells = [];
  try { upsells = JSON.parse(($('#kd-upsell-data') || {}).textContent || '[]'); } catch (e) {}

  function setCount(n) {
    $$('[data-kd-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function openCart() { if (!drawer) return; drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { if (!drawer) return; drawer.classList.remove('is-open'); document.body.style.overflow = ''; }

  var ccfg = {};
  try { ccfg = JSON.parse(($('#kd-cart-cfg') || {}).textContent || '{}'); } catch (e) {}
  /* compare-at prices are not in /cart.js: read them once per product from /products/<handle>.js */
  var cmpCache = {};
  try { cmpCache = JSON.parse(sessionStorage.getItem('kdCmp') || '{}'); } catch (e) {}
  upsells.forEach(function (u) { cmpCache[u.variant_id] = u.compare || 0; });
  function loadCompare(items) {
    var need = {};
    items.forEach(function (it) { if (!(it.variant_id in cmpCache) && it.handle) need[it.handle] = 1; });
    var hs = Object.keys(need);
    if (!hs.length) return Promise.resolve(false);
    return Promise.all(hs.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p) p.variants.forEach(function (v) { cmpCache[v.id] = v.compare_at_price || 0; });
      }).catch(function () {});
    })).then(function () { try { sessionStorage.setItem('kdCmp', JSON.stringify(cmpCache)); } catch (e) {} return true; });
  }
  var ICON_TRASH = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>';
  var ICON_TAG = '<svg viewBox="0 0 24 24" width="10" height="10" aria-hidden="true"><path fill="currentColor" d="M3 12.5V4h8.5L21 13.5 13.5 21 3 12.5zm4-5.7a1.3 1.3 0 100 2.6 1.3 1.3 0 000-2.6z"/></svg>';
  var ICON_SHIELD = '<svg viewBox="0 0 24 24" width="34" height="34" aria-hidden="true"><path fill="#121212" d="M12 2l8 3v6c0 5.2-3.4 9.4-8 11-4.6-1.6-8-5.8-8-11V5l8-3z"/><path d="M8 12l3 3 5-6" fill="none" stroke="#fff" stroke-width="2"/></svg>';
  function sw(on, attr) { return '<button type="button" class="kd-sw" role="switch" aria-checked="' + (on ? 'true' : 'false') + '" ' + attr + '><span></span></button>'; }

  function renderCart(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    var body = $('[data-kd-cart-body]', drawer), foot = $('[data-kd-cart-foot]', drawer);
    var title = $('[data-kd-cart-title]', drawer), banner = $('[data-kd-cart-banner]', drawer);
    var prot = ccfg.protection;
    var lines = cart.items.filter(function (it) { return !(prot && it.variant_id === prot.variant_id); });
    var protLine = prot ? cart.items.filter(function (it) { return it.variant_id === prot.variant_id; })[0] : null;
    if (title) title.textContent = 'Votre panier • ' + cart.item_count + (cart.item_count > 1 ? ' articles' : ' article');
    if (!lines.length) {
      if (banner) banner.hidden = true;
      body.innerHTML = '<div class="kd-cart__empty"><p>' + esc(cfg.emptyText || 'Your cart is empty') + '</p><a class="kd-btn" href="' + esc(cfg.shopUrl || '/collections/all') + '">' + esc(cfg.continueText || 'Continue shopping') + '</a></div>';
      foot.hidden = true;
      return;
    }
    if (banner && ccfg.banner) { banner.textContent = ccfg.banner; banner.hidden = false; }
    foot.hidden = false;
    var savings = 0;
    var variantCount = {};
    (cart.items || []).forEach(function (i) { variantCount[i.variant_id] = (variantCount[i.variant_id] || 0) + i.quantity; });
    var html = lines.map(function (it) {
      var cmp = cmpCache[it.variant_id] || 0;
      var unitOrig = Math.max(cmp, it.original_price);
      var lineOrig = unitOrig * it.quantity, fin = it.final_line_price;
      if (lineOrig > fin) savings += lineOrig - fin;
      var unit = (unitOrig > it.final_price ? '<s>' + money(unitOrig) + '</s> ' : '') + '<b>' + money(it.final_price) + '</b>';
      var tags = (it.line_level_discount_allocations || []).map(function (d) { return '<span class="kd-ci__tag">' + ICON_TAG + esc(d.discount_application.title) + '</span>'; }).join('');
      var plan = it.selling_plan_allocation ? '<div class="kd-ci__v">' + esc(it.selling_plan_allocation.selling_plan.name) + '</div>' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="kd-ci__v">' + esc(it.variant_title) + '</div>' : '';
      var right = (lineOrig > fin ? '<s>' + money(lineOrig) + '</s> ' : '') + '<b>' + money(fin) + '</b>' + (lineOrig > fin ? '<em>(Vous économisez ' + money(lineOrig - fin) + ')</em>' : '');
      return '<div class="kd-ci" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '" class="kd-ci__img">' + (it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="kd-ci__main"><div class="kd-ci__top"><p class="kd-ci__t">' + esc(it.product_title) + '</p><button type="button" class="kd-ci__rm" data-kd-rm aria-label="' + esc(cfg.removeText || 'Retirer') + '">' + ICON_TRASH + '</button></div>' +
        variant + Object.keys(it.properties || {}).filter(function (k) { return k[0] !== '_' && it.properties[k]; }).map(function (k) { return '<div class="kd-ci__v">' + esc(k) + ' : ' + esc(it.properties[k]) + '</div>'; }).join('') + plan + '<div class="kd-ci__unit">' + unit + tags + '</div>' +
        '<div class="kd-ci__row"><div class="kd-qty" role="group" aria-label="Quantité de ' + esc(it.product_title) + '">' +
          '<button type="button" data-kd-q="-1" aria-label="Diminuer la quantité" ' + (it.quantity <= 1 ? 'disabled' : '') + '>−</button>' +
          '<span data-kd-quantity aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" data-kd-q="1" aria-label="Augmenter la quantité" ' + (variantCount[it.variant_id] >= 5 ? 'disabled' : '') + '>+</button></div><div class="kd-ci__p">' + right + '</div></div></div></div>';
    }).join('');
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.variant_id] = i.key; });
    var ups = upsells.filter(function (u) { return u.available && (!prot || u.variant_id !== prot.variant_id); }).slice(0, 3);
    if (ups.length) {
      html += '<div class="kd-up"><h4>' + esc(ccfg.bundleTitle || cfg.upsellTitle || 'Vous aimerez aussi') + '</h4>' + ups.map(function (u) {
        return '<div class="kd-up__i"><img src="' + esc(u.image) + '" alt="" loading="lazy"><b>' + esc(u.title) + '</b><span class="kd-up__p"><b>' + money(u.price) + '</b>' + (u.compare > u.price ? '<s>' + money(u.compare) + '</s>' : '') + '</span>' + sw(!!inCart[u.variant_id], 'data-kd-up="' + u.variant_id + '" aria-label="' + esc(u.title) + '"') + '</div>';
      }).join('') + '</div>';
    }
    body.innerHTML = html;
    var pbox = $('[data-kd-protect]', drawer);
    if (pbox) pbox.innerHTML = prot ? '<div class="kd-prot">' + ICON_SHIELD + '<div><b>' + esc(prot.title) + '</b><span>' + esc(prot.text) + '</span></div><div class="kd-prot__r"><b>' + money(prot.price) + '</b>' + sw(!!protLine, 'data-kd-up="' + prot.variant_id + '" aria-label="' + esc(prot.title) + '"') + '</div></div>' : '';
    savings += cart.total_discount || 0;
    var dRow = $('[data-kd-disc-row]', drawer);
    dRow.hidden = savings <= 0;
    $('[data-kd-disc]', drawer).textContent = '-' + money(savings);
    $('[data-kd-total]', drawer).textContent = money(cart.total_price);
    $('[data-kd-sub]', drawer).textContent = money(cart.original_total_price);
    drawer.__cart = cart;
    if (window.MBCKPriceRouter) window.MBCKPriceRouter.refresh(cart);
    loadCompare(lines).then(function (changed) { if (changed && drawer.__cart === cart) renderCart(cart); });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('Panier indisponible'); return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  // Retain all selected variants, including bundles, and enforce 1-5 units per variant.
  function normalize() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Panier indisponible'); return r.json(); })
      .then(function (cart) {
        var ops = (cart.items || []).filter(function (it) { return it.quantity > 5; })
          .map(function (it) { return { id: it.key, quantity: 5 }; });
        return ops.reduce(function (p, o) { return p.then(function () { return post('/cart/change.js', o); }); }, Promise.resolve());
      });
  }
  function addItems(items) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Panier indisponible'); return r.json(); })
      .then(function (cart) {
        var count = {};
        (cart.items || []).forEach(function (it) { count[it.variant_id] = (count[it.variant_id] || 0) + it.quantity; });
        var safe = [];
        (items || []).forEach(function (i) {
          var variant = Number(i.id), wanted = Math.max(1, Math.floor(Number(i.quantity) || 1));
          var remaining = Math.max(0, 5 - (count[variant] || 0));
          var quantity = Math.min(wanted, remaining);
          if (!quantity) return;
          safe.push(Object.assign({}, i, { quantity: quantity }));
          count[variant] = (count[variant] || 0) + quantity;
        });
        if (!safe.length) throw new Error('Maximum 5 unités par article.');
        return post('/cart/add.js', { items: safe });
      })
      .then(function () { return refresh(); });
  }
  window.KDCart = { open: openCart, refresh: refresh, add: addItems, normalize: normalize };

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-kd-close]') || t.classList.contains('kd-cart__ov')) return closeCart();
      var row = t.closest('.kd-ci');
      var up = t.closest('[data-kd-up]');
      if (up) {
        up.disabled = true;
        var vid = +up.getAttribute('data-kd-up');
        var line = (drawer.__cart && drawer.__cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
        var done = function () { up.disabled = false; };
        if (line) return post('/cart/change.js', { id: line.key, quantity: 0 }).then(renderCart).then(done, function () { done(); refresh(); });
        return addItems([{ id: vid, quantity: 1 }]).then(done, done);
      }
      if (!row) return;
      var key = row.getAttribute('data-key');
      var q = t.closest('[data-kd-q]');
      if (q) {
        var current = (drawer.__cart && drawer.__cart.items || []).find(function (i) { return i.key === key; });
        if (!current) return refresh();
        var cur = current.quantity;
        var totalVariant = (drawer.__cart.items || []).filter(function (i) { return i.variant_id === current.variant_id; })
          .reduce(function (sum, i) { return sum + i.quantity; }, 0);
        var maxForLine = Math.max(1, 5 - (totalVariant - cur));
        var next = Math.max(1, Math.min(maxForLine, cur + Number(q.getAttribute('data-kd-q'))));
        if (next === cur) return;
        $$('[data-kd-q]', row).forEach(function (b) { b.disabled = true; });
        post('/cart/change.js', { id: key, quantity: next })
          .then(function (cart) { renderCart(cart); })
          .catch(function (error) { console.warn('Quantité panier', error); refresh(); });
      } else if (t.closest('[data-kd-rm]')) {
        post('/cart/change.js', { id: key, quantity: 0 }).then(renderCart).catch(refresh);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-kd-open-cart]');
    if (o) { e.preventDefault(); refresh().then(openCart); }
    var m = e.target.closest('[data-kd-menu]');
    if (m) { var n = $('#kd-mnav'); if (n) n.classList.toggle('is-open'); }
    if (e.target.id === 'kd-mnav') e.target.classList.remove('is-open');
  });
  refresh();

  /* collection filters */
  document.addEventListener('change', function (e) { var f = e.target.closest && e.target.closest('[data-kd-coll]'); if (f) f.submit(); });

  /* quick add on cards */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kd-quick]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    addItems([{ id: +b.getAttribute('data-kd-quick'), quantity: 1 }]).then(function () { b.disabled = false; openCart(); }).catch(function (error) { b.disabled = false; openCart(); console.warn('Ajout au panier :', error.message); });
  });

  /* ---------- Gallery ---------- */
  $$('[data-kd-gallery]').forEach(function (g) {
    var slides = $$('.kd-gal__slide', g), thumbs = $$('.kd-gal__thumb', g), dots = $$('.kd-gal__dot', g), i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (thumbs[i] && thumbs[i].offsetParent) thumbs[i].parentNode.scrollTo({ left: thumbs[i].offsetLeft - thumbs[i].parentNode.offsetLeft - 40, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    var p = $('[data-prev]', g), n = $('[data-next]', g);
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (n) n.addEventListener('click', function () { go(i + 1); });
    var x0 = null;
    g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
  });

  /* ---------- Delivery estimate ---------- */
  $$('[data-kd-eta]').forEach(function (el) {
    function ord(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
    function fmt(d) { return new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(d) + ', ' + new Intl.DateTimeFormat('en-US', { month: 'long' }).format(d) + ' ' + ord(d.getDate()); }
    function add(n) { var x = new Date(); x.setDate(x.getDate() + n); return x; }
    el.innerHTML = esc(el.getAttribute('data-label')) + ' <strong>' + esc(fmt(add(+el.getAttribute('data-min')))) + '</strong> and <strong>' + esc(fmt(add(+el.getAttribute('data-max')))) + '</strong>.';
  });

  /* ---------- Order-by date ---------- */
  $$('[data-kd-today]').forEach(function (el) {
    function ord(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
    var d = new Date(); el.textContent = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(d) + ' ' + ord(d.getDate());
  });

  /* ---------- Delivery timeline (simple PDP) ---------- */
  $$('[data-kd-steps]').forEach(function (el) {
    function ord(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
    function fmt(d) { return new Intl.DateTimeFormat('en-US', { month: 'short' }).format(d) + ' ' + ord(d.getDate()); }
    function add(n) { var x = new Date(); x.setDate(x.getDate() + n); return x; }
    var g = function (k) { return +el.getAttribute('data-d' + k); };
    $('[data-s1]', el).textContent = fmt(add(0));
    $('[data-s2]', el).textContent = fmt(add(g(1))) + ' - ' + fmt(add(g(2)));
    $('[data-s3]', el).textContent = fmt(add(g(3))) + ' - ' + fmt(add(g(4)));
  });

  /* ---------- Carousels & videos ---------- */
  $$('[data-kd-car]').forEach(function (c) {
    var t = $('.kd-car__track', c), step = function () { var i = $('.kd-car__item', t); return i ? i.getBoundingClientRect().width + 20 : 300; };
    var p = $('[data-prev]', c), n = $('[data-next]', c);
    if (p) p.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kd-play]');
    if (!b) return;
    var box = b.parentElement, v = $('video', box);
    if (!v) return;
    $$('.kd-car__item video').forEach(function (o) { if (o !== v) o.pause(); });
    box.classList.add('kd-vid--on'); v.controls = true; v.play();
  });

  /* ---------- PDP bundles (cream / tiers / simple) ---------- */
  $$('[data-kd-pdp]').forEach(function (root) {
    var dataEl = $('script[data-kd-offers]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var radios = $$('input[name="kd-offer"]', root);
    var buyBtn = $('[data-kd-buy]', root), err = $('[data-kd-err]', root);
    var boxList = $('[data-kd-box-lines]', root), boxTotal = $('[data-kd-box-total]', root), boxSave = $('[data-kd-box-save]', root);
    var sticky = $('[data-kd-sticky-price]', root);
    var subToggle = $('[data-kd-sub-toggle]', root), planSel = $('[data-kd-plan]', root);

    function isSub() { return !!(subToggle && subToggle.checked); }
    function syncMode() {
      radios.forEach(function (r) {
        var m = data.offers[+r.value].mode, lab = r.closest('.kd-offer');
        lab.hidden = !(m === 'any' || (m === 'sub') === isSub());
      });
      var vis = radios.filter(function (r) { return !r.closest('.kd-offer').hidden; });
      if (vis.length && !vis.some(function (r) { return r.checked; })) vis[0].checked = true;
    }
    function current() {
      var c = radios.filter(function (r) { return r.checked && !r.closest('.kd-offer').hidden; })[0];
      return data.offers[c ? +c.value : 0];
    }
    function unitPrice(o) {
      if (o.mode === 'sub' && planSel) {
        var pl = (o.plans || []).filter(function (p) { return String(p.id) === planSel.value; })[0];
        if (pl) return pl.price;
      }
      return o.price;
    }
    function totals(o) {
      var pay = unitPrice(o) * o.qty;
      var orig = (o.compare > o.price ? o.compare : o.price) * o.qty;
      return { pay: pay, orig: Math.max(orig, pay) };
    }
    function render() {
      var o = current();
      if (!o) return;
      var t = totals(o);
      if (boxList) {
        var rows = [];
        rows.push('<div class="kd-line"><div class="kd-line__img">' + (data.main.image ? '<img src="' + esc(data.main.image) + '" alt="">' : '') + (o.boxQty ? '<span class="kd-line__qty">' + esc(o.boxQty) + '</span>' : '') + '</div><div><b>' + esc(o.boxTitle || data.main.title) + '</b><span class="m">' + esc(o.boxSub || '') + '</span></div><div class="p">' + (t.orig > t.pay ? '<s>' + money(t.orig) + '</s>' : '') + '<em>' + money(t.pay) + '</em></div></div>');
        (o.gifts || []).forEach(function (g) {
          rows.push('<div class="kd-line"><div class="kd-line__img"><img src="' + esc(g.image) + '" alt=""></div><div><b>' + esc(g.title) + '</b><span class="m">' + esc(g.sub || cfg.gift || 'Free gift') + '</span></div><div class="p"><s>' + money(g.price) + '</s><em>' + esc(cfg.freeText || 'FREE') + '</em></div></div>');
        });
        var tail = [];
        if (o.locked) {
          tail.push('<div class="kd-line is-locked"><div class="kd-line__img kd-line__img--lock"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg></div><div><b>' + esc(o.locked.title) + '</b><span class="m">' + esc(o.locked.sub) + '</span></div><div class="p"><s>' + esc(o.locked.strike) + '</s><span class="kd-lockbtn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg>' + esc(o.locked.label) + '</span></div></div>');
        }
        boxList.innerHTML = rows.join('');
        var boxTail = $('[data-kd-box-tail]', root);
        if (boxTail) boxTail.innerHTML = tail.join(''); else boxList.innerHTML += tail.join('');
      }
      if (boxTotal) boxTotal.innerHTML = money(t.pay) + (t.orig > t.pay ? ' <s>' + money(t.orig) + '</s>' : '');
      if (boxSave) { boxSave.textContent = t.orig > t.pay ? (cfg.youSave || 'You save') + ' ' + (o.pct ? o.pct : money(t.orig - t.pay)) : ''; boxSave.hidden = !(t.orig > t.pay); }
      if (sticky) sticky.innerHTML = money(t.pay) + (t.orig > t.pay ? ' <s>' + money(t.orig) + '</s>' : '');
      var cards = $$('[data-kd-card]', root);
      if (cards.length) {
        var tier = data.offers.indexOf(o) + 1, un = 0, val = 0, bars = $$('[data-kd-bar]', root);
        cards.forEach(function (c, k) {
          var ok = +c.getAttribute('data-unlock') <= tier;
          c.classList.toggle('is-locked', !ok); if (bars[k]) bars[k].classList.toggle('is-off', !ok);
          if (ok) { un++; val += +c.getAttribute('data-value'); }
        });
        var sub = $('[data-kd-gifts-sub]', root), cur = $('[data-kd-gifts]', root).getAttribute('data-currency') || '';
        if (sub) sub.textContent = un + ' of ' + cards.length + ' unlocked, ' + cur + val.toFixed(2) + ' value';
      }
    }
    function items() {
      var o = current(), arr = [];
      var main = { id: o.variant, quantity: o.qty };
      if (o.mode === 'sub' && planSel) main.selling_plan = +planSel.value;
      arr.push(main);
      (o.gifts || []).forEach(function (g) { arr.push({ id: g.variant, quantity: g.qty || 1 }); });
      return arr;
    }
    function run(buy, btn) {
      err.textContent = '';
      btn.disabled = true;
      window.KDCart.add(items())
        .then(function () {
          if (!buy) { window.KDCart.open(); return true; }
          if (window.MBCKPriceRouter) return window.MBCKPriceRouter.checkout().then(function (ok) {
            if (!ok) { err.textContent = 'Vérifiez le montant dans votre panier avant de payer.'; window.KDCart.open(); }
            return ok;
          });
          window.KDCart.open();
          err.textContent = 'Paiement momentanément indisponible.';
          return false;
        })
        .catch(function (e) { err.textContent = e.message || 'Ajout impossible'; })
        .then(function () { btn.disabled = false; });
    }
    radios.forEach(function (r) { r.addEventListener('change', render); });
    if (subToggle) subToggle.addEventListener('change', function () { syncMode(); render(); });
    if (planSel) planSel.addEventListener('change', render);
    syncMode(); render();
    $$('[data-kd-add],[data-kd-sticky-add]', root).forEach(function (b) { b.addEventListener('click', function () { run(false, b); }); });
    if (buyBtn) buyBtn.addEventListener('click', function () { run(true, buyBtn); });
    var st = $('.kd-sticky', root), main = $('[data-kd-add]', root);
    if (st && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { st.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(main);
    }
  });
})();

/* scroller carousel (home essentials on mobile): arrows + dots */
(function () {
  document.querySelectorAll('[data-kd-scroller]').forEach(function (root) {
    var tr = root.querySelector('[data-kd-scroller-track]'), dots = root.querySelectorAll('[data-kd-dot]');
    if (!tr) return;
    function step() { var c = tr.children[1]; return c ? c.offsetLeft - tr.children[0].offsetLeft : tr.clientWidth; }
    function idx() { return Math.max(0, Math.min(dots.length - 1, Math.round(tr.scrollLeft / (step() || 1)))); }
    function paint() { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
    var p = root.querySelector('[data-kd-prev]'), n = root.querySelector('[data-kd-next]');
    if (p) p.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    paint();
  });
})();
